// React
import React, { FunctionComponent } from 'react'

// Styles
import {
  AddresLabel,
  Container,
  Content,
  FooterItemContainer,
  FooterItemContent,
  FooterItemTitle,
  Header,
  LinksAndPaymentCompositionWrapper,
  LinksCompositionWrapper,
  Logo,
  PaymentCompositionWrapper,
  Separator,
  SocialMediaCompositionWrapper
} from './footer.styles'

// Types
import { FooterProps } from './footer.types'

// Assets
import logo from './assets/proenem.svg'

// Components
import { ConditionallyRender } from 'components/utilities/conditionally-render'

export const Footer: FunctionComponent<FooterProps> = ({
  addressLabel,
  socialMediaComposition,
  linksComposition,
  paymentComposition,
  scrollToTopElement
}) => {
  return (
    <Container>
      <Content>
        {scrollToTopElement}

        <Header>
          <Logo src={logo} />

          <SocialMediaCompositionWrapper>
            {socialMediaComposition}
          </SocialMediaCompositionWrapper>
        </Header>

        <LinksAndPaymentCompositionWrapper>
          <LinksCompositionWrapper>{linksComposition}</LinksCompositionWrapper>

          <PaymentCompositionWrapper>
            {paymentComposition}
          </PaymentCompositionWrapper>
        </LinksAndPaymentCompositionWrapper>

        <Separator />

        <AddresLabel>{addressLabel}</AddresLabel>
      </Content>
    </Container>
  )
}

export const FooterItem: FunctionComponent<any> = ({
  title,
  content,
  guidance = 'vertical'
}) => {
  return (
    <FooterItemContainer>
      <ConditionallyRender
        shouldRender={!!title}
        content={<FooterItemTitle>{title}</FooterItemTitle>}
      />

      <FooterItemContent guidance={guidance}>{content}</FooterItemContent>
    </FooterItemContainer>
  )
}
